<div class="eazix-exhibition"
  [class.eazix-exhibition-ltr]="!isRTL"
  [class.eazix-exhibition-dark]="isDarkMode">
  <div *ngIf="filterUserId || haveWall" class="eazix-exhibition-share-slot"
    [class.eazix-exhibition-share-slot-collapsed]="isScrolledDown">
    <button *ngIf="filterUserId" type="button"
      class="eazix-exhibition-share-btn"
      [matTooltip]="'wall.exhibition.back-to-exhibition' | translate"
      matTooltipPosition="below"
      matTooltipTouchGestures="off"
      [matTooltipDisabled]="!shareNavTooltipEnabled()"
      (click)="backToExhibition()">
      <mat-icon>favorite</mat-icon>
      <span>{{ 'wall.exhibition.back-to-exhibition' | translate }}</span>
    </button>
    <button *ngIf="!filterUserId && haveWall" type="button"
      class="eazix-exhibition-share-btn"
      [matTooltip]="'wall.personal.title' | translate"
      matTooltipPosition="below"
      matTooltipTouchGestures="off"
      [matTooltipDisabled]="!shareNavTooltipEnabled()"
      (click)="goToMyWall()">
      <mat-icon>wallpaper</mat-icon>
      <span>{{ 'wall.personal.title' | translate }}</span>
    </button>
  </div>

  <div *ngIf="!filterUserId" class="eazix-exhibition-filter-slot"
    [class.eazix-exhibition-share-slot-collapsed]="isScrolledDown && !filterPanelOpen"
    [class.is-open]="filterPanelOpen"
    [class.is-active]="hasActiveFeedFilters()">
    <button type="button"
      class="eazix-exhibition-share-btn eazix-exhibition-filter-float-btn"
      [class.is-open]="filterPanelOpen"
      [class.is-active]="hasActiveFeedFilters()"
      [matTooltip]="'wall.exhibition.filter.title' | translate"
      matTooltipPosition="below"
      matTooltipTouchGestures="off"
      [matTooltipDisabled]="!shareNavTooltipEnabled() || filterPanelOpen"
      (click)="toggleFilterPanel()"
      [attr.aria-expanded]="filterPanelOpen"
      [attr.aria-label]="'wall.exhibition.filter.title' | translate">
      <mat-icon>tune</mat-icon>
      <span>{{ 'wall.exhibition.filter.title' | translate }}</span>
    </button>

    <div *ngIf="filterPanelOpen" class="eazix-exhibition-filter-panel eazix-exhibition-filter-panel-float"
      role="region"
      [attr.aria-label]="'wall.exhibition.filter.title' | translate">
      <div class="eazix-exhibition-filter-field">
        <label class="eazix-exhibition-filter-label" for="exhibition-filter-academy">
          {{ 'wall.exhibition.filter.academy' | translate }}
        </label>
        <mat-form-field appearance="outline" class="eazix-exhibition-filter-select w-100">
          <mat-select id="exhibition-filter-academy"
            [ngModel]="filterAcademy"
            (ngModelChange)="onFilterAcademyChange($event)"
            [placeholder]="'wall.exhibition.filter.academy-all' | translate">
            <mat-select-trigger>
              <span class="eazix-exhibition-filter-option" *ngIf="filterAcademy">
                <img class="eazix-exhibition-filter-option-logo"
                  [src]="academyLogoUrl(filterAcademy)"
                  alt=""
                  (error)="onAcademyLogoError($event)">
                <span>{{ fullAcademyLabel(filterAcademy) }}</span>
              </span>
              <span *ngIf="!filterAcademy">{{ 'wall.exhibition.filter.academy-all' | translate }}</span>
            </mat-select-trigger>
            <mat-option value="">{{ 'wall.exhibition.filter.academy-all' | translate }}</mat-option>
            <mat-option *ngFor="let opt of academyOptions" [value]="opt.serialName">
              <span class="eazix-exhibition-filter-option">
                <img class="eazix-exhibition-filter-option-logo"
                  [src]="academyLogoUrl(opt.serialName)"
                  alt=""
                  (error)="onAcademyLogoError($event)">
                <span>{{ opt.labelKey | translate }}</span>
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="eazix-exhibition-filter-field">
        <span class="eazix-exhibition-filter-label">{{ 'wall.exhibition.filter.status' | translate }}</span>
        <div class="eazix-exhibition-filter-toggles" role="group"
          [attr.aria-label]="'wall.exhibition.filter.status' | translate">
          <button type="button"
            class="eazix-exhibition-filter-toggle"
            [class.is-on]="filterLooking"
            [attr.aria-pressed]="filterLooking"
            (click)="toggleFilterLooking()">
            <mat-icon>work_outline</mat-icon>
            <span>{{ 'wall.personal.status.looking' | translate }}</span>
          </button>
          <button type="button"
            class="eazix-exhibition-filter-toggle"
            [class.is-on]="filterHelping"
            [attr.aria-pressed]="filterHelping"
            (click)="toggleFilterHelping()">
            <mat-icon>groups</mat-icon>
            <span>{{ 'wall.personal.status.helping' | translate }}</span>
          </button>
        </div>
        <p class="eazix-exhibition-filter-hint mb-0">{{ 'wall.exhibition.filter.status-hint' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="eazix-exhibition-inner">
    <header class="eazix-exhibition-header">
      <h1 class="eazix-exhibition-title mb-0">
        <ng-container *ngIf="!filterUserId">{{ 'wall.exhibition.title' | translate }}</ng-container>
        <span *ngIf="filterUserId" class="eazix-exhibition-user-wall-title">
          <span class="eazix-exhibition-owner-avatar"
            [attr.aria-hidden]="true">
            <img *ngIf="filterProfile?.authorImageURL"
              [src]="filterProfile.authorImageURL"
              alt=""
              referrerpolicy="no-referrer"
              (error)="onFilterOwnerAvatarError()">
            <span *ngIf="!filterProfile?.authorImageURL">{{ filterOwnerInitial() }}</span>
          </span>
          <span>{{ 'wall.exhibition.user-wall' | translate:{ name: filterTitleName() } }}</span>
        </span>
      </h1>
      <p *ngIf="!filterUserId" class="eazix-exhibition-subtitle mb-0">
        {{ 'wall.exhibition.subtitle' | translate }}
      </p>

      <div *ngIf="!filterUserId && hasActiveFeedFilters()"
        class="eazix-exhibition-filter-chips eazix-exhibition-filter-chips-header"
        aria-live="polite">
        <button *ngIf="filterAcademy" type="button"
          class="eazix-exhibition-filter-chip"
          (click)="clearFeedFilterAcademy()"
          [attr.aria-label]="('wall.exhibition.filter.clear-one' | translate:{ label: fullAcademyLabel(filterAcademy) })">
          <img *ngIf="filterAcademy" class="eazix-exhibition-filter-chip-logo"
            [src]="academyLogoUrl(filterAcademy)"
            alt=""
            (error)="onAcademyLogoError($event)">
          <span>{{ fullAcademyLabel(filterAcademy) }}</span>
          <mat-icon>close</mat-icon>
        </button>
        <button *ngIf="filterLooking" type="button"
          class="eazix-exhibition-filter-chip"
          (click)="clearFeedFilterLooking()"
          [attr.aria-label]="('wall.exhibition.filter.clear-one' | translate:{ label: ('wall.personal.status.looking' | translate) })">
          <mat-icon class="eazix-exhibition-filter-chip-icon">work_outline</mat-icon>
          <span>{{ 'wall.personal.status.looking' | translate }}</span>
          <mat-icon>close</mat-icon>
        </button>
        <button *ngIf="filterHelping" type="button"
          class="eazix-exhibition-filter-chip"
          (click)="clearFeedFilterHelping()"
          [attr.aria-label]="('wall.exhibition.filter.clear-one' | translate:{ label: ('wall.personal.status.helping' | translate) })">
          <mat-icon class="eazix-exhibition-filter-chip-icon">groups</mat-icon>
          <span>{{ 'wall.personal.status.helping' | translate }}</span>
          <mat-icon>close</mat-icon>
        </button>
        <button type="button"
          class="eazix-exhibition-filter-clear"
          (click)="clearAllFeedFilters()">
          {{ 'wall.exhibition.filter.clear' | translate }}
        </button>
      </div>

      <div *ngIf="filterUserId && filterProfile" class="eazix-exhibition-subtitle eazix-exhibition-owner-meta mb-0">
          <div *ngIf="(filterProfile.about || '').trim() || fullAcademyLabel(filterProfile.academySerialName)"
          class="eazix-exhibition-owner-about-row">
          <p *ngIf="(filterProfile.about || '').trim()" class="eazix-exhibition-owner-about mb-0">{{ (filterProfile.about || '').trim() }}</p>
          <span *ngIf="(filterProfile.about || '').trim() && fullAcademyLabel(filterProfile.academySerialName)"
            class="eazix-exhibition-owner-about-dot"
            aria-hidden="true">·</span>
          <span *ngIf="fullAcademyLabel(filterProfile.academySerialName)"
            class="eazix-exhibition-owner-academy">
            <img class="eazix-exhibition-owner-academy-logo"
              [src]="academyLogoUrl(filterProfile.academySerialName)"
              alt=""
              (error)="onAcademyLogoError($event)">
            <span>{{ fullAcademyLabel(filterProfile.academySerialName) }}</span>
          </span>
        </div>
        <div class="eazix-exhibition-owner-status"
          *ngIf="filterProfile.lookingForWork || filterProfile.offeringHelp || isContactAllowed(filterProfile.allowContact)">
          <div *ngIf="filterProfile.lookingForWork || filterProfile.offeringHelp"
            class="eazix-exhibition-owner-flags">
            <span *ngIf="filterProfile.lookingForWork" class="eazix-exhibition-owner-status-item">
              <mat-icon>work_outline</mat-icon>
              <span>{{ 'wall.personal.status.looking' | translate }}</span>
            </span>
            <span *ngIf="filterProfile.offeringHelp" class="eazix-exhibition-owner-status-item">
              <mat-icon>groups</mat-icon>
              <span>{{ 'wall.personal.status.helping' | translate }}</span>
            </span>
          </div>
          <button *ngIf="isContactAllowed(filterProfile.allowContact) && !isOwnUser(filterProfile.userID)" type="button"
            class="eazix-exhibition-owner-contact"
            (click)="openContactAuthor(filterProfile.userID, filterProfile.authorName, $event)">
            <mat-icon>mail_outline</mat-icon>
            <span>{{ 'wall.exhibition.contact-author' | translate }}</span>
          </button>
        </div>
      </div>
    </header>

    <div *ngIf="!isLoading && loadError" class="eazix-exhibition-empty">
      <mat-icon>cloud_off</mat-icon>
      <b>{{ 'wall.exhibition.load-error' | translate }}</b>
      <button type="button" mat-stroked-button color="primary" class="rounded-pill mt-3"
        (click)="retryLoad()">
        {{ 'wall.exhibition.retry' | translate }}
      </button>
    </div>

    <div *ngIf="!isLoading && !loadError && !cards.length" class="eazix-exhibition-empty">
      <mat-icon>{{ hasActiveFeedFilters() && !filterUserId ? 'filter_list_off' : 'collections' }}</mat-icon>
      <b>{{
        (filterUserId
          ? 'wall.exhibition.user-wall-empty'
          : (hasActiveFeedFilters() ? 'wall.exhibition.filter.empty' : 'wall.exhibition.empty'))
        | translate
      }}</b>
      <button *ngIf="hasActiveFeedFilters() && !filterUserId"
        type="button"
        mat-stroked-button
        color="primary"
        class="rounded-pill mt-3"
        (click)="clearAllFeedFilters()">
        {{ 'wall.exhibition.filter.clear' | translate }}
      </button>
    </div>

    <div *ngIf="!loadError && (cards.length || skeletonSlots.length)"
      #collage
      class="eazix-exhibition-collage"
      [attr.aria-busy]="isLoading || isLoadingMore"
      [style.--gallery-gap.px]="layoutGap"
      [style.height.px]="layoutTotalHeight">
      <div class="eazix-exhibition-row"
        *ngFor="let row of layoutRows; trackBy: trackRow"
        [style.top.px]="row.top"
        [style.z-index]="commentsTargetId ? null : row.zIndex"
        [style.height.px]="row.maxHeight"
        [style.gap.px]="layoutGap">
      <article *ngFor="let item of row.items; trackBy: trackLayoutItem"
        class="eazix-exhibition-card"
        [attr.data-wall-card-id]="item.work._id"
        [class.eazix-exhibition-card-skeleton]="isSkeletonWork(item.work)"
        [class.eazix-exhibition-card-slot-held]="!isSkeletonWork(item.work) && item.work.commentsMounted"
        [style.width.px]="item.width"
        [style.height.px]="!isSkeletonWork(item.work) && item.work.commentsMounted ? item.height : null"
        [style.flex]="'0 0 auto'">
        <div *ngIf="isSkeletonWork(item.work)"
          class="eazix-exhibition-card-media is-loading"
          [style.height.px]="item.height">
          <div class="eazix-exhibition-card-shimmer"></div>
        </div>
        <ng-container *ngIf="!isSkeletonWork(item.work) && item.work as card">
        <div class="eazix-exhibition-card-panel"
          [attr.data-focus-panel]="card._id"
          [class.eazix-exhibition-card-focus]="card.commentsMounted"
          [class.eazix-exhibition-card-focus-panoramic]="card.commentsMounted && isFocusPanoramic(card)"
          [class.eazix-exhibition-card-focus-fill]="isFocusHeightCapped(card)"
          [class.eazix-exhibition-card-open]="card.commentsOpen">
        <div class="eazix-exhibition-focus-scroll">
        <div class="eazix-exhibition-card-shell"
          [style.height.px]="card.commentsMounted ? null : item.height">
        <div class="eazix-exhibition-card-media"
          [attr.data-wall-item-id]="card._id"
          [class.eazix-exhibition-card-media-sized]="!!card.natW"
          [class.is-loading]="!card.imgLoaded"
          [style.height.px]="card.commentsMounted ? null : item.height"
          [style.aspect-ratio]="card.commentsMounted ? mediaAspectRatio(card) : null"
          [style.--focus-ar]="card.commentsMounted ? mediaAspectValue(card) : null"
          (click)="card.commentsOpen ? $event.stopPropagation() : openCommentsFromImage(card, $event)">
          <div class="eazix-exhibition-card-media-clip">
          <img [src]="card.thumbUrl"
            [alt]="card.title || card.fileName || ''"
            class="eazix-exhibition-card-img"
            [class.eazix-exhibition-card-img-fitted]="!!card.natW"
            [class.eazix-exhibition-card-img-sideways]="isSideways(card.rotation)"
            [class.is-pending]="!card.imgLoaded"
            [style.transform]="imageTransform(card.rotation)"
            loading="lazy"
            (load)="onCardImageLoad($event, card)"
            (error)="onCardImageError($event, card)">
          </div>
          <div *ngIf="!card.imgLoaded" class="eazix-exhibition-card-shimmer"></div>

          <div class="eazix-exhibition-card-overlay"
            [class.is-off]="card.commentsMounted"
            (click)="openCommentsFromOverlay(card, $event)">
            <button type="button"
              class="eazix-exhibition-stat-btn eazix-exhibition-like-hit eazix-exhibition-card-like-btn"
              [class.eazix-exhibition-stat-liked]="card.likedByMe"
              [disabled]="card.liking"
              (click)="onLike(card, $event)"
              [attr.aria-label]="'wall.exhibition.like' | translate">
              <mat-icon>{{ card.likedByMe ? 'favorite' : 'favorite_border' }}</mat-icon>
              <ng-container *ngIf="showExhibitionLikeCount(item.width)">
                <span>{{ card.likeCount }}</span>
                <span *ngIf="card.likeCount > 0 && topLikers(card.recentLikers).length"
                  class="eazix-exhibition-likers-tip"
                  aria-hidden="true">
                  <span *ngFor="let n of topLikers(card.recentLikers)"
                    class="eazix-exhibition-likers-name"
                    [attr.title]="n">{{ shortAuthorName(n) }}</span>
                  <span *ngIf="card.likeCount > 3" class="eazix-exhibition-likers-more">...</span>
                </span>
              </ng-container>
            </button>
            <button *ngIf="!isExhibitionCardNarrow(item.width)"
              type="button"
              class="eazix-exhibition-stat-btn"
              [class.eazix-exhibition-stat-active]="card.commentsOpen"
              (mouseenter)="ensureCommentersTip(card)"
              (click)="toggleComments(card, $event)"
              [attr.aria-label]="'wall.exhibition.comments' | translate">
              <span class="eazix-exhibition-stat-icon eazix-exhibition-like-hit">
                <mat-icon>{{ card.commentsOpen ? 'chat_bubble' : 'chat_bubble_outline' }}</mat-icon>
                <span *ngIf="card.commentCount > 0"
                  class="eazix-exhibition-likers-tip"
                  aria-hidden="true">
                  <span *ngFor="let n of topLikers(card.recentCommenters)"
                    class="eazix-exhibition-likers-name"
                    [attr.title]="n">{{ shortAuthorName(n) }}</span>
                  <span *ngIf="hasMoreCommenters(card)" class="eazix-exhibition-likers-more">...</span>
                </span>
              </span>
              <span>{{ card.commentCount }}</span>
            </button>
          </div>
        </div>

          <div *ngIf="!card.commentsMounted && !filterUserId && (card.authorName || card.lookingForWork || card.offeringHelp)"
            class="eazix-exhibition-card-hover-meta eazix-exhibition-card-hover-meta--compact">
            <div *ngIf="card.authorName" class="eazix-exhibition-card-author"
              [attr.title]="card.authorName + (card.academySerialName ? (' · ' + fullAcademyLabel(card.academySerialName)) : '')">
              {{ cardOverlayAuthorName(card) }}
              <span *ngIf="card.academySerialName"> · {{ cardOverlayAcademyName(card) }}</span>
            </div>
            <div *ngIf="card.lookingForWork || card.offeringHelp"
              class="eazix-exhibition-status-badges"
              (click)="$event.stopPropagation()">
              <span *ngIf="card.lookingForWork"
                class="eazix-exhibition-status-badge-hit"
                [class.is-open]="card.statusTip === 'looking'"
                (click)="onStatusBadgeClick(card, 'looking', $event)">
                <mat-icon class="eazix-exhibition-status-badge">work_outline</mat-icon>
                <span class="eazix-exhibition-status-tip">{{ 'wall.personal.status.looking' | translate }}</span>
              </span>
              <span *ngIf="card.offeringHelp"
                class="eazix-exhibition-status-badge-hit"
                [class.is-open]="card.statusTip === 'helping'"
                (click)="onStatusBadgeClick(card, 'helping', $event)">
                <mat-icon class="eazix-exhibition-status-badge">groups</mat-icon>
                <span class="eazix-exhibition-status-tip">{{ 'wall.personal.status.helping' | translate }}</span>
              </span>
            </div>
          </div>
        </div>

        <div class="eazix-exhibition-comments-clip"
          [class.is-open]="card.commentsOpen">
        <div class="eazix-exhibition-comments-fold">
        <div *ngIf="card.commentsMounted" class="eazix-exhibition-comments"
          [class.is-empty]="!card.commentsLoading && !card.comments.length && card.likeCount <= 0"
          [class.no-send]="!(card.draftComment || '').trim() && !card.commenting"
          (click)="$event.stopPropagation()">
          <div class="eazix-exhibition-author-actions" *ngIf="!filterUserId">
            <div *ngIf="card.authorName || card.lookingForWork || card.offeringHelp"
              class="eazix-exhibition-author-identity">
              <div *ngIf="card.authorName" class="eazix-exhibition-author-identity-name"
                [attr.title]="card.authorName + (card.academySerialName ? (' · ' + fullAcademyLabel(card.academySerialName)) : '')">
                {{ card.authorName }}
                <span *ngIf="card.academySerialName" class="eazix-exhibition-author-identity-academy">
                  · {{ fullAcademyLabel(card.academySerialName) }}
                </span>
              </div>
              <div *ngIf="card.lookingForWork || card.offeringHelp" class="eazix-exhibition-author-flags">
                <span *ngIf="card.lookingForWork" class="eazix-exhibition-author-flag">
                  <mat-icon>work_outline</mat-icon>
                  <span>{{ 'wall.personal.status.looking' | translate }}</span>
                </span>
                <span *ngIf="card.offeringHelp" class="eazix-exhibition-author-flag">
                  <mat-icon>groups</mat-icon>
                  <span>{{ 'wall.personal.status.helping' | translate }}</span>
                </span>
              </div>
            </div>
            <div class="eazix-exhibition-author-action-group">
            <button type="button"
              class="eazix-exhibition-author-action"
              (click)="openAuthorWall(card, $event)">
              <mat-icon>collections</mat-icon>
              <span>{{ 'wall.exhibition.view-author-works' | translate }}</span>
            </button>
            <button *ngIf="isContactAllowed(card.allowContact) && !isOwnUser(card.userID)" type="button"
              class="eazix-exhibition-author-action"
              (click)="openContactAuthor(card.userID, card.authorName, $event)">
              <mat-icon>mail_outline</mat-icon>
              <span class="eazix-exhibition-author-action-short">{{ 'wall.exhibition.contact-author' | translate }}</span>
              <span class="eazix-exhibition-author-action-full">{{ 'wall.exhibition.contact-author' | translate }}</span>
            </button>
            </div>
          </div>
          <div *ngIf="card.title || card.description" class="eazix-exhibition-work-meta">
            <div *ngIf="card.title" class="eazix-exhibition-work-text-row">
              <b class="eazix-exhibition-work-title"
                [class.is-expanded]="card.workTitleExpanded"
                [wallLineOverflow]="!card.workTitleExpanded"
                (wallLineOverflowing)="onWorkTitleOverflow(card, $event)"
                [attr.title]="card.title">{{ displayWorkText(card.title) }}</b>
              <button *ngIf="isWorkTitleOverflow(card)"
                type="button"
                class="eazix-exhibition-work-text-toggle"
                [class.is-open]="card.workTitleExpanded"
                (click)="toggleWorkText(card, 'title', $event)">
                {{ (card.workTitleExpanded ? 'wall.exhibition.less' : 'wall.exhibition.more') | translate }}
              </button>
            </div>
            <div *ngIf="card.description" class="eazix-exhibition-work-text-row">
              <p class="eazix-exhibition-work-desc mb-0"
                [class.is-expanded]="card.workDescExpanded"
                [wallLineOverflow]="!card.workDescExpanded"
                (wallLineOverflowing)="onWorkDescOverflow(card, $event)"
                [attr.title]="card.description">{{ displayWorkText(card.description) }}</p>
              <button *ngIf="isWorkDescOverflow(card)"
                type="button"
                class="eazix-exhibition-work-text-toggle"
                [class.is-open]="card.workDescExpanded"
                (click)="toggleWorkText(card, 'description', $event)">
                {{ (card.workDescExpanded ? 'wall.exhibition.less' : 'wall.exhibition.more') | translate }}
              </button>
            </div>
          </div>
          <div class="eazix-exhibition-liked-block">
            <div class="eazix-exhibition-liked-names">
              <button type="button"
                class="eazix-exhibition-stat-btn eazix-exhibition-like-hit eazix-exhibition-liked-toggle"
                [class.eazix-exhibition-stat-liked]="card.likedByMe"
                [disabled]="card.liking"
                (click)="onLike(card, $event)"
                [attr.aria-label]="'wall.exhibition.like' | translate">
                <mat-icon>{{ card.likedByMe ? 'favorite' : 'favorite_border' }}</mat-icon>
                <span>{{ card.likeCount }}</span>
              </button>
              <span *ngFor="let n of visibleLikers(card)"
                class="eazix-exhibition-liked-pill"
                [class.wall-truncated-name]="isLikerNameTruncated(n)"
                [class.c-pointer]="isLikerNameTruncated(n)"
                #likerTip="matTooltip"
                [matTooltip]="n"
                matTooltipPosition="above"
                matTooltipShowDelay="1000000"
                matTooltipHideDelay="0"
                matTooltipTouchGestures="off"
                [matTooltipDisabled]="!isLikerNameTruncated(n)"
                (click)="showTruncatedNameTip($event, likerTip, n)"
                (mouseleave)="hideTruncatedNameTip(likerTip)">
                <span class="wall-truncated-name-label">{{ likerDisplayName(n) }}</span>
              </span>
              <button *ngIf="canExpandLikers(card)"
                type="button"
                class="eazix-exhibition-liked-more"
                (click)="toggleLikersExpand(card, $event)">
                {{ (card.likersExpanded ? 'wall.exhibition.less' : 'wall.exhibition.more') | translate }}
              </button>
            </div>
          </div>

          <div *ngIf="card.commentsLoading && commentsLoadReservePx(card) > 0"
            class="eazix-exhibition-comments-reserve"
            [style.height.px]="commentsLoadReservePx(card)"
            aria-hidden="true"></div>
          <ul *ngIf="visibleComments(card).length"
            class="eazix-exhibition-comments-list mb-0"
            [attr.data-comments-list]="card._id">
            <li *ngFor="let thread of visibleComments(card); trackBy: trackCommentThread"
              class="eazix-exhibition-comment-thread">
              <ng-container
                *ngTemplateOutlet="commentRowTpl; context: { $implicit: thread.comment, card: card }">
              </ng-container>

              <button type="button"
                class="eazix-exhibition-reply-btn"
                [class.is-open]="thread.comment.replying"
                (click)="toggleReply(card, thread.comment, $event)">
                <mat-icon>{{ isRTL ? 'subdirectory_arrow_left' : 'subdirectory_arrow_right' }}</mat-icon>
                <span>{{ 'wall.exhibition.reply' | translate }}</span>
              </button>

              <div *ngIf="thread.comment.replying"
                class="eazix-exhibition-comment-compose eazix-exhibition-reply-compose"
                [class.no-send]="!(thread.comment.draftReply || '').trim() && !thread.comment.commentingReply"
                [attr.data-reply-compose]="thread.comment._id">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 eazix-exhibition-comment-field">
                  <textarea matInput
                    rows="1"
                    [(ngModel)]="thread.comment.draftReply"
                    (input)="onReplyInput($event, card, thread.comment)"
                    (keydown.control.enter)="$event.preventDefault(); submitReply(card, thread.comment)"
                    (keydown.meta.enter)="$event.preventDefault(); submitReply(card, thread.comment)"
                    [placeholder]="'wall.exhibition.write-reply' | translate"
                    maxlength="1000"
                    [attr.data-reply-edit]="thread.comment._id">
                  </textarea>
                </mat-form-field>
                <button
                  type="button" mat-button color="primary"
                  class="rounded-pill eazix-exhibition-send-comment-btn"
                  [attr.data-reply-send]="thread.comment._id"
                  [disabled]="thread.comment.commentingReply || !(thread.comment.draftReply || '').trim()"
                  (click)="submitReply(card, thread.comment)">
                  {{ (thread.comment.commentingReply ? 'wall.exhibition.sending' : 'wall.exhibition.send-reply') | translate }}
                </button>
              </div>

              <ul *ngIf="thread.replies?.length" class="eazix-exhibition-replies mb-0">
                <li *ngFor="let r of thread.replies; trackBy: trackCommentById">
                  <ng-container
                    *ngTemplateOutlet="commentRowTpl; context: { $implicit: r, card: card }">
                  </ng-container>
                </li>
              </ul>
            </li>
          </ul>
          <div class="eazix-exhibition-comments-end-spacer" aria-hidden="true"></div>
        </div>
        </div>
        </div>
        </div>
        <div *ngIf="card.commentsMounted" class="eazix-exhibition-comment-compose eazix-exhibition-compose-dock"
          [class.is-reply-compose-open]="hasOpenReply(card)"
          [class.no-send]="!(card.draftComment || '').trim() && !card.commenting"
          (click)="$event.stopPropagation()">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 eazix-exhibition-comment-field">
            <textarea matInput
              rows="1"
              [(ngModel)]="card.draftComment"
              (input)="onComposeInput($event, card)"
              (keydown.control.enter)="$event.preventDefault(); submitComment(card)"
              (keydown.meta.enter)="$event.preventDefault(); submitComment(card)"
              [placeholder]="'wall.exhibition.write-comment' | translate"
              maxlength="1000"
              [attr.data-compose-edit]="card._id">
            </textarea>
          </mat-form-field>
          <button *ngIf="(card.draftComment || '').trim() || card.commenting"
            type="button" mat-button color="primary"
            class="rounded-pill eazix-exhibition-send-comment-btn"
            [disabled]="card.commenting"
            (click)="submitComment(card)">
            {{ (card.commenting ? 'wall.exhibition.sending' : 'wall.exhibition.send-comment') | translate }}
          </button>
        </div>
        </div>
        </ng-container>
      </article>
      </div>
    </div>

    <div *ngIf="!isLoading && cards.length && hasMore"
      class="eazix-exhibition-row-sentinel-wrap"
      aria-hidden="true">
      <div #sentinel class="eazix-exhibition-sentinel"></div>
    </div>

    <div *ngIf="!isLoading && !isLoadingMore && cards.length && !hasMore"
      class="eazix-exhibition-end">
      {{ 'wall.exhibition.no-more' | translate }}
    </div>
  </div>
  <div *ngIf="!isLoading && !isLoadingMore && cards.length && !hasMore"
    class="eazix-exhibition-new-order-bar">
    <button type="button"
      class="w-100 rounded-pill fw-bold text-white zx-small-btn"
      mat-raised-button
      color="primary"
      (click)="goToNewOrder()">
      {{ 'main-nav.new-order' | translate }}
    </button>
  </div>
  <div class="eazix-exhibition-focus-backdrop"
    *ngIf="commentsTargetId"
    [class.is-visible]="isFocusCloseVisible()"
    (click)="closeActiveCommentsFocus()"
    aria-hidden="true"></div>
  <button *ngIf="isFocusCloseVisible()"
    type="button"
    class="eazix-exhibition-focus-close"
    (pointerdown)="$event.stopPropagation()"
    (click)="onFocusCloseClick($event)"
    [attr.aria-label]="'close-branch.btn' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>

<ng-template #commentRowTpl let-c let-card="card">
  <div class="eazix-exhibition-comment-row">
    <div class="eazix-exhibition-comment-avatar"
      [class.c-pointer]="!!c.userID"
      [attr.aria-label]="c.authorName || ('wall.personal.anonymous' | translate)"
      (click)="openCommentAuthorWall(c, $event)">
      <img *ngIf="c.authorImageURL" [src]="c.authorImageURL" alt=""
        referrerpolicy="no-referrer"
        (error)="onCommentAvatarError(c)">
      <span *ngIf="!c.authorImageURL">{{ commentInitial(c) }}</span>
    </div>
    <div class="eazix-exhibition-comment-body">
      <div class="eazix-exhibition-comment-meta">
        <span class="eazix-exhibition-comment-uname"
          [class.wall-truncated-name]="isCommentAuthorNameTruncated(c.authorName)"
          [class.c-pointer]="!!c.userID || isCommentAuthorNameTruncated(c.authorName)"
          #commentNameTip="matTooltip"
          [matTooltip]="c.authorName || ''"
          matTooltipPosition="above"
          matTooltipShowDelay="1000000"
          matTooltipHideDelay="0"
          matTooltipTouchGestures="off"
          [matTooltipDisabled]="!isCommentAuthorNameTruncated(c.authorName)"
          (click)="openCommentAuthorWall(c, $event); showTruncatedNameTip($event, commentNameTip, c.authorName)"
          (mouseleave)="hideTruncatedNameTip(commentNameTip)">
          <span class="wall-truncated-name-label">{{ c.authorName ? commentAuthorDisplayName(c.authorName) : ('wall.personal.anonymous' | translate) }}</span>
        </span>
        <span *ngIf="c.created" class="eazix-exhibition-comment-time">{{ commentTimeLabel(c) }}</span>
      </div>
      <div *ngIf="!c.editing" class="eazix-exhibition-comment-text-row">
        <p class="eazix-exhibition-comment-text mb-0"
          [wallCommentClamp]="!isCommentTextExpanded(c)"
          (wallCommentOverflow)="onCommentTextOverflow(c._id, $event)">{{ c.text }}</p>
        <button *ngIf="showCommentTextMore(c)"
          type="button"
          class="eazix-exhibition-comment-text-more"
          (click)="expandCommentText(c, $event)">{{ 'wall.exhibition.more' | translate }}</button>
        <button *ngIf="showCommentTextLess(c)"
          type="button"
          class="eazix-exhibition-comment-text-more"
          (click)="collapseCommentText(c, $event)">{{ 'wall.exhibition.less' | translate }}</button>
      </div>
      <div *ngIf="c.editing" class="eazix-exhibition-comment-edit-wrap">
        <textarea
          class="eazix-exhibition-comment-edit-input"
          [class.has-save]="isCommentDirty(c)"
          rows="1"
          [(ngModel)]="c.draftText"
          maxlength="1000"
          [disabled]="c.saving"
          [attr.data-comment-edit]="c._id"
          (click)="$event.stopPropagation()"
          (input)="resizeCommentField($event)"
          (keydown.escape)="cancelEditComment(c); $event.preventDefault()">
        </textarea>
        <button *ngIf="isCommentDirty(c)"
          type="button"
          class="eazix-exhibition-comment-save"
          [disabled]="c.saving || !(c.draftText || '').trim()"
          (click)="saveEditComment(card, c); $event.stopPropagation()">
          {{ (c.saving ? 'wall.exhibition.sending' : 'wall.exhibition.save-comment') | translate }}
        </button>
      </div>
      <div class="eazix-exhibition-comment-like-row">
        <button type="button"
          class="eazix-exhibition-comment-like eazix-exhibition-like-hit"
          [class.is-liked]="c.likedByMe"
          [disabled]="c.liking"
          (click)="onCommentLike(card, c, $event)"
          [attr.aria-label]="'wall.exhibition.like' | translate">
          <mat-icon>{{ c.likedByMe ? 'favorite' : 'favorite_border' }}</mat-icon>
          <span>{{ c.likeCount || 0 }}</span>
          <span *ngIf="(c.likeCount || 0) > 0 && topLikers(c.recentLikers).length"
            class="eazix-exhibition-likers-tip eazix-exhibition-likers-tip-light"
            aria-hidden="true">
            <span *ngFor="let n of topLikers(c.recentLikers)"
              class="eazix-exhibition-likers-name"
              [attr.title]="n">{{ shortAuthorName(n) }}</span>
            <span *ngIf="(c.likeCount || 0) > 3" class="eazix-exhibition-likers-more">...</span>
          </span>
        </button>
        <button *ngIf="(c.likeCount || 0) > 0"
          type="button"
          class="eazix-exhibition-comment-likers-toggle"
          [class.is-open]="c.likersExpanded"
          (click)="toggleCommentLikers(card, c, $event)"
          [attr.aria-label]="(c.likersExpanded ? 'wall.exhibition.less' : 'wall.exhibition.more') | translate">
          <mat-icon>{{ c.likersExpanded ? 'remove' : 'add' }}</mat-icon>
        </button>
        <div *ngIf="isMyComment(c)" class="eazix-exhibition-comment-tools">
          <button type="button"
            class="eazix-exhibition-comment-pen"
            [class.is-editing]="c.editing"
            [disabled]="c.saving"
            (click)="c.editing ? cancelEditComment(c) : startEditComment(card, c, $event); $event.stopPropagation()"
            [attr.aria-label]="(c.editing ? 'wall.exhibition.remove-pen' : 'wall.exhibition.edit-comment') | translate">
            <mat-icon>{{ c.editing ? 'edit_off' : 'edit' }}</mat-icon>
          </button>
          <span *ngIf="c.editing" class="eazix-exhibition-comment-delete-wrap">
            <button type="button"
              class="eazix-exhibition-comment-delete"
              [matMenuTriggerFor]="deleteCommentMenu"
              [disabled]="c.saving"
              (click)="$event.stopPropagation()"
              [attr.aria-label]="'wall.exhibition.delete-comment' | translate">
              <mat-icon>delete</mat-icon>
            </button>
            <mat-menu #deleteCommentMenu="matMenu" xPosition="before" yPosition="below">
              <button mat-menu-item
                class="eazix-exhibition-comment-delete-menu-item"
                [disabled]="c.saving"
                (click)="deleteComment(card, c); $event.stopPropagation()">
                <mat-icon>delete_forever</mat-icon>
                <span>{{ 'wall.exhibition.delete-comment' | translate }}</span>
              </button>
            </mat-menu>
          </span>
        </div>
        <div *ngIf="c.likersExpanded && commentLikers(c).length"
          class="eazix-exhibition-comment-likers">
          <span *ngFor="let n of commentLikers(c)"
            class="eazix-exhibition-liked-pill"
            [class.wall-truncated-name]="isLikerNameTruncated(n)"
            [class.c-pointer]="isLikerNameTruncated(n)"
            #commentLikerTip="matTooltip"
            [matTooltip]="n"
            matTooltipPosition="above"
            matTooltipShowDelay="1000000"
            matTooltipHideDelay="0"
            matTooltipTouchGestures="off"
            [matTooltipDisabled]="!isLikerNameTruncated(n)"
            (click)="showTruncatedNameTip($event, commentLikerTip, n)"
            (mouseleave)="hideTruncatedNameTip(commentLikerTip)">
            <span class="wall-truncated-name-label">{{ likerDisplayName(n) }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
